import { createContext, useContext } from "react"

import { ComponentNavigationContextValues } from "./ComponentNavigation.types"

export const ComponentNavigationContext = createContext<ComponentNavigationContextValues | undefined>(undefined)
ComponentNavigationContext.displayName = "ComponentNavigationContext"

export function useComponentNavigation(): ComponentNavigationContextValues {
    const context = useContext(ComponentNavigationContext)
    if (!context) {
        throw new Error("useComponentNavigation must be used within a ComponentNavigation component")
    }
    return context
}
